import {GiftCardFragment} from '../../../../gql/graphql';

export class GiftCardModel {
  public id: string;
  public obfuscatedCode: string;

  constructor(params: GiftCardModel) {
    this.id = params.id;
    this.obfuscatedCode = params.obfuscatedCode;
  }

  public static fromCheckoutV1(giftCard?: GiftCardFragment | null) {
    if (!giftCard) {
      return undefined;
    }
    return new GiftCardModel({
      id: giftCard.id!,
      obfuscatedCode: giftCard.obfuscatedCode!,
    });
  }
}
